/*
 * @Author: yuanjianlong
 * @Description:
 * @Date: 2021-08-17 10:37:30
 * @LastEditTime: 2021-12-03 14:40:33
 * @FilePath: /teacher-h5/src/store/modules/userInfo.js
 */
const state = {
  username: '',
  userList: [],
  userInfo: {} // 用户信息
}

// 自定义改变state初始值的方法
const mutations = {
  username (state, name) {
    state.username = name
  },
  setUserList (state, id) {
    state.userList.push(id)
  },
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo
  }
}

// 自定义触发mutations里函数的方法
const actions = {
  username ({ commit }, name) {
    commit('username', name)
  }
}

const getters = {
  username: state => state.username,
  userInfo: state => state.userInfo
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
